/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { useState } from "react";

import { Button, Typography } from "@bigbinary/neeto-atoms";
import { Loader2 } from "lucide-react";
import { Toastr } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation, Trans } from "react-i18next";

import { DEFAULT_EMAIL, DEFAULT_PASSWORD } from "./constants";
import SignInForm from "./Form";

const SignIn = ({ handleSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(null);
  const { t } = useTranslation();

  const redirectAfterSuccessfulLogin = redirectTo => {
    window.location.pathname = redirectTo || "/";
  };

  const handleFormSubmit = async formValues => {
    try {
      const response = await handleSubmit({ user: formValues });
      Toastr.success(t("neetoMolecules.login.success"));
      redirectAfterSuccessfulLogin(response.redirectTo);
    } catch {
      /* empty */
    }
  };

  const loginAsOliver = async () => {
    setIsSubmitting(true);
    await handleFormSubmit({
      email: DEFAULT_EMAIL,
      password: DEFAULT_PASSWORD,
    });
    setIsSubmitting(false);
  };

  return (
    <div className="flex h-dvh w-full justify-center">
      <div className="bg-background border-border flex w-full max-w-lg flex-col gap-y-6 self-center rounded-lg border p-8 shadow-sm sm:min-w-max sm:p-10">
        <Typography variant="h3" weight="medium">
          <Trans
            components={{ bold: <b /> }}
            i18nKey="neetoMolecules.login.toOrganizationAccount"
            values={{ organizationName: globalProps.organization.name }}
          />
        </Typography>
        <Button
          className="w-full"
          disabled={isSubmitting}
          size="lg"
          variant="default"
          onClick={loginAsOliver}
        >
          {isSubmitting && <Loader2 className="animate-spin" size={16} />}
          {t("neetoMolecules.login.loginAsOliver")}
        </Button>
        <Typography className="text-center" variant="body1" weight="semibold">
          {t("neetoMolecules.common.or").toLocaleUpperCase()}
        </Typography>
        <SignInForm {...{ handleFormSubmit }} />
      </div>
    </div>
  );
};

SignIn.propTypes = {
  /**
   * The function that is triggered when login button is clicked.
   */
  handleSubmit: PropTypes.func,
};

export default SignIn;
